import React, { useMemo, useState } from 'react';
import { parseDeadlineFromText } from './parse_deadline';

export default function TodoInput({
  onAdd,
  placeholder = 'Add an item, e.g. milk today 6.00 pm',
  kind = 'task',
  disabled = false,
}) {
  const [value, setValue] = useState('');

  const parsed = useMemo(() => parseDeadlineFromText(value), [value]);

  const submit = () => {
    const text = value.trim();
    if (!text || disabled) return;
    const result = parseDeadlineFromText(text);
    onAdd({
      title: result.title || text,
      kind,
      due_at: result.dueAt,
      reminder_at: result.reminderAt,
    });
    setValue('');
  };

  return (
    <div className="todo-input-wrap">
      <input
        type="text"
        className="todo-smart-input"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') submit();
        }}
      />
      {kind === 'task' && parsed.label && (
        <div className="todo-deadline-hint">
          Reminder: <strong>{parsed.label}</strong>
          {parsed.title && parsed.title !== value.trim() && (
            <span className="todo-deadline-hint-title"> · {parsed.title}</span>
          )}
        </div>
      )}
    </div>
  );
}
